export default __webpack_public_path__ + "static/media/trainer.bbb91778.svg";